import { extendGlobal } from '@misc/extend-global'

export const setWebpackBuildInfo = () => {
  extendGlobal('info', {
    build: GIT_REVISION,
    branch: GIT_BRANCH
  })
}
